<template>
	<div
		class="relative mb-2 hover:opacity-80 min-w-[176px] w-full aspect-square"
	>
		<NuxtImg
			:src="category.Files[0]?.ImagePath + '?w=250&h=250&format=webp'"
			:alt="`Category ${category.Name}`"
			:class="`object-cover object-center absolute w-full h-full`"
			draggable="false"
			:loading="lazyLoading ? 'lazy' : 'eager'"
			:preload="!lazyLoading"
		/>
	</div>
	<span class="font-medium uppercase">{{ category.Name }}</span>
</template>

<script setup lang="ts">
import type { CategoryWithFiles } from "@nwt/norce-pwa/dist/runtime/types/api/category/category";

interface Props {
	category: CategoryWithFiles;
	lazyLoading: boolean | undefined;
}

defineProps<Props>();
</script>
